import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import DurationService from "app/services/DurationService";
import { DefaultFetchService } from "app/services/fetchService";
import { i18nFilter } from "app/filters/i18nFilter";
import { minAbbrNumberFilter } from "app/filters/ngFilters";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import { ContentWrapper, LoaderWrapper, TopPart, TotalVisitsWrapper } from "./StyledComponents";
import { WidgetLoader } from "app/components/widget-loader/WidgetLoader";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";

import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import { useCurrentStateAndParams } from "@uirouter/react";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";

const TitleContainer = styled.div`
    padding: 20px 12px 20px 20px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

const fetchService = DefaultFetchService.getInstance();
const i18n = i18nFilter();

export const TotalVisits: FunctionComponent<any> = ({ isMonetizationPage = false }) => {
    const { params } = useCurrentStateAndParams();
    const { country, isWWW, key, duration, filter } = params;
    const durationObject = DurationService.getDurationData(duration);
    const { from, to, isWindow } = durationObject.forAPI;
    const title = i18n("analysis.publishers.ads.totalvisits.title");
    const tooltip = i18n("analysis.publishers.ads.totalvisits.tooltip");
    const [data, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const subTitleFilters = [
        {
            filter: "date",
            value: {
                from,
                to,
                format: "MMMM YYYY",
            },
        },
        {
            filter: "webSource",
            value: "Desktop",
        },
    ];

    useEffect(() => {
        async function fetchData() {
            const API = `api/websiteanalysis/GetTrafficDisplayPaidOutgoing`;
            const response = await fetchService.get<any>(API, {
                country,
                from,
                isWWW: isWWW === "-",
                isWindow,
                key,
                to,
                params: {
                    page: 1,
                    orderby: "Share desc",
                },
            });
            if (Object.keys(response.dictionary[key]).length) {
                console.log("total visits: ", response);
                setData(response);
            } else {
                setData(null);
            }
            setIsLoading(false);
        }
        fetchData();
    }, []);

    const getComponent = () =>
        data ? (
            <TopPart>
                <TotalVisitsWrapper>{minAbbrNumberFilter()(data.dictionary[key]?.VolumeTotal)}</TotalVisitsWrapper>
            </TopPart>
        ) : (
            <NoDataLandscape
                title="global.nodata.notavilable"
                subtitle={null}
            />
        );

    return (
        <>
            <TitleContainer>
                <WidgetTitle
                    title={title}
                    tooltip={tooltip}
                    filters={subTitleFilters}
                >
                    <AddToDashboard
                        metric={
                            isMonetizationPage ? "DashboardTrafficSourcesAds" : "DashboardTrafficSourcesAdsAdvertisers"
                        }
                        type="SingleMetric"
                        modelType="fromWebsite"
                        webSource={devicesTypes.DESKTOP as IWidgetModelTypesWebSource}
                        filters={filter}
                    />
                </WidgetTitle>
            </TitleContainer>
            {isLoading ? (
                <LoaderWrapper>
                    <WidgetLoader />
                </LoaderWrapper>
            ) : (
                <ContentWrapper>{getComponent()}</ContentWrapper>
            )}
        </>
    );
};
